import socket, { invokeRPC } from './socket.js'

export function getFaqs () {
  return invokeRPC('faqs', 'getFaqs')
}

export function batchUpdate (data) {
  return invokeRPC('faqs', 'getFaqs', data)
}

export function deleteFaq (id) {
  return invokeRPC('faqs', 'deleteFaq', id)
}
